/* storybook-check-ignore */
import React from 'react';
import { Box, Text } from '@opendoor/bricks/core';
import InfoIcon from '../../redventures/icons/InfoIcon';
import { DynamicComponentAfterLoad } from 'components/shared/dynamic';
import { TooltipProps } from '@opendoor/bricks/complex';

const Tooltip: React.FC<{ analyticsName: string }> = ({ analyticsName, children }) => {
  return (
    <span>
      <DynamicComponentAfterLoad<TooltipProps>
        dynamicLoaderFunction={() =>
          import('@opendoor/bricks/complex/Tooltip').then((mod) => mod.Tooltip)
        }
        popupDirection="bottom"
        label="mls"
        width="100%"
        height="100%"
        tooltipIcon={
          <Box transform="translateY(4px)" display="inline-block" width="20px" height="20px">
            <InfoIcon alt="More Information" />
          </Box>
        }
        analyticsName={analyticsName}
      >
        <Text
          padding={[null, null, null, null, '5px']}
          fontSize={['s00', 's0', 's0', 's0', 's0']}
          fontWeight="semibold"
          color="neutrals0"
        >
          {children}
        </Text>
      </DynamicComponentAfterLoad>
    </span>
  );
};

export default Tooltip;
